const Loading = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div
        className="h-8 w-8 animate-spin rounded-full border-2 border-transparent border-t-[#0d9488]"
      />
    </div>
  );
};

export default Loading; 